import { render, staticRenderFns } from "./SurveyAdminFinish.vue?vue&type=template&id=78472b44&scoped=true"
import script from "./SurveyAdminFinish.vue?vue&type=script&lang=js"
export * from "./SurveyAdminFinish.vue?vue&type=script&lang=js"
import style0 from "./SurveyAdminFinish.vue?vue&type=style&index=0&id=78472b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78472b44",
  null
  
)

export default component.exports